﻿// import { obterLocalizacao, loadBotao, loadFullPage, postFetch } from "./utilidades";
import { obterLocalizacao } from './utilidades/obterLocalizacao';
import { loadBotao } from './utilidades/loadBotao';
import { loadFullPage } from './utilidades/loadFullPage';
import { postFetch } from './utilidades/postFetch';
import IMask from "imask";
import JustValidate from "just-validate";
import i18next from 'i18next';
import { inicializarInternacionalizacao } from './localizacao/login-esqueci-senha/login-esqueci-senha';
import { addTrack } from "./utilidades/trackEventos";
import { getGeoData } from './utilidades/geoData';
import { obterCandidaturaPendente } from './utilidades/candidaturaPendente';

const _templateQuestionario = function (titulo, perguntas) {
    var html = [];

    html.push(`<h2 class="text-primary text-center">${i18next.t('RecuperarSenhaTituloQuestionario')}</h1>`);
    html.push('<p class="text-center"><b>' + titulo + '</b></p>');
    for (var i = 0; i < perguntas.length; i++) {
        html.push('<button type="button" class="btn btn-default w-100 mb-3 btn-resposta">' + perguntas[i] + '</button>');
    }
    return html.join('');
};
const _templateFinalizouQuestionario = function (link) {
    var html = [];
    html.push(`<h1 class="h3 text-primary text-center">${i18next.t('RecuperarSenhaQuestionarioConcluidoTitulo')}</h1>`);

    html.push(`<p class="text-center">${i18next.t('RecuperarSenhaQuestionarioConcluidoTexto')}</p>`);

    html.push('<div class="d-grid gap-2"><a href="' + link + `" class="btn btn-success text-light"><i class="bi bi-pencil-square"></i> ${i18next.t('RecuperarSenhaQuestionarioConcluidoTextoBotao')}</button></div>`);

    return html.join('');
};

const esqueciSenha = function () {

    const $form = document.getElementById('form-esqueci-senha');
    const botaoSolicitar = document.getElementById('btn-esqueci-senha');
    let paisID = '';
    const _call = async () => {
        loadBotao.mostrar(botaoSolicitar);
        const formData = new FormData($form);

        const callbackSucesso = (resultado) => {
            loadBotao.esconder(botaoSolicitar);
            if (resultado.sucesso) {
                const containerPessoa = document.getElementById('container-pessoas');

                if (resultado.pessoas && resultado.pessoas.length > 0) {
                    $form.classList.add("d-none");
                    containerPessoa.classList.remove('d-none');
                    const lista = containerPessoa.querySelector('.list-group');
                    const html = [];

                    html.push('<div class="list-group">');
                    for (var i = 0; i < resultado.pessoas.length; i++) {
                        html.push(`
                            <a href="javascript:void(0)" class="list-group-item pessoa-escolha" data-id="${resultado.pessoas[i].ID}">
                                <div class="nome-pessoa" data-id="${resultado.pessoas[i].ID}">${resultado.pessoas[i].Nome}</div>
                                <div class="clearfix"></div>
                            </a>
                        `)
                    }
                    html.push('</div>');
                    lista.innerHTML = html.join('');

                    lista.querySelectorAll('.pessoa-escolha').forEach(pe => pe.addEventListener('click', async event => {
                        const formData = new FormData($form);
                        formData.append('id', event.target.getAttribute('data-id'));

                        await postFetch(`/${CULTURE_EMPREGARE}/candidato/esqueci-senha`, formData, callbackSucesso, callbackErro, callbackErro);
                    }));

                    document.getElementById('cancelar-varias-pessoas-esqueci-senha').addEventListener('click', () => {
                        $form.classList.remove('d-none');
                        containerPessoa.classList.add('d-none');
                    })

                    return;
                }
                
                paisID = resultado.paisID;
                $form.classList.add("d-none");
                containerPessoa.classList.toggle('d-none', true);
                const $containerEscolher = document.getElementById('container-escolher-alteracao');

                document.getElementById('TokenUsuario').value = resultado.token;

                $containerEscolher.classList.remove('d-none');

                // $form.querySelector('#cpf').value = '';
                // $form.querySelector('#email').value = '';
                $form.querySelector('#emailCpf').value = '';
                
                if (paisID === 'BR') {
                    document.getElementById('btnAlterarSenhaQuestionario').classList.remove('d-none');
                } else {
                    document.getElementById('btnAlterarSenhaQuestionario').classList.add('d-none');
                }
            } else {
                let $rowErro = $form.querySelector('#row-erro');
                $rowErro.classList.remove('d-none');
                $rowErro.querySelector('.retorno-mensagem').innerHTML = resultado.mensagem;
            }
        }
        const callbackErro = (resultado) => {
            loadBotao.esconder(botaoSolicitar);

            let $rowErro = $form.querySelector('#row-erro');
            $rowErro.classList.remove('d-none');
            $rowErro.querySelector('.retorno-mensagem').innerHTML = resultado.mensagem;
        }
        
        const callbackErroConexao = () => {
            loadBotao.esconder(botaoSolicitar);
            let $rowErro = $form.querySelector('#row-erro');
            $rowErro.classList.remove('d-none');
        }
        
        await postFetch(`/${CULTURE_EMPREGARE}/candidato/esqueci-senha`, formData, callbackSucesso, callbackErro, callbackErroConexao);

    };
    const _callAlterarSenhaEmail = async () => {
        loadFullPage.mostrar();

        const token = document.getElementById('TokenUsuario').value;
        const $container = document.getElementById('container-escolher-alteracao');

        const callbackSucesso = (resultado) => {
            loadFullPage.esconder();

            addTrack('Recuperacao Senha', { recuperacaoPor: 'email' });

            $container.innerHTML = `
                <h1 class="h3 text-primary text-center mb-4">${i18next.t('RecuperarSenhaEnvioEmail')}</h1>
                <div class="text-center">
                    <p><b class="text-success">${i18next.t('RecuperarSenhaEnvioEmailInformacoes')}</b></p>
                    <h5><b>${resultado.email}</b></h5>
                    <p>${i18next.t('RecuperarSenhaEnvioEmailVerificarSpam')}</p> 
                    <p class="text-center"><a href="#" id="naoTenhoAcessoEmail" class="btn w-100 btn-outline-primary">${i18next.t('RecuperarSenhoEnvioEmailObterOutroEmail')}</a></p>
                </div>`;

            $container.classList.remove('d-none');

            document.getElementById('container-questionario').classList.add('d-none');

            $container.querySelector('#naoTenhoAcessoEmail').addEventListener('click', function () {
                if (paisID != 'BR') {
                    return window.location.href = 'https://www.empregare.com/pt-br/suporte/novo';
                }
                _callAlterarSenhaQuestionario();
                return false;
            }, false);


        }
        const callbackErro = () => {
            loadFullPage.esconder();
        }

        let formData = new FormData();
        formData.append('token', token);

        const candidaturaPendente = obterCandidaturaPendente();
        if (candidaturaPendente.vagaID != '0') {
            formData.append('vagaID', candidaturaPendente.vagaID);
            formData.append('redirect', `${candidaturaPendente.url}?confirmar=1`);
        }
        await postFetch(`/${CULTURE_EMPREGARE}/Login/AlterarSenhaViaEmail`, formData, callbackSucesso, callbackErro, callbackErro);
    };

    const _callResponderQuestionario = async (resposta) => {
        loadFullPage.mostrar();
        const token = document.getElementById('TokenUsuario').value;
        const tipoPergunta = document.getElementById('TipoPergunta').value;
        const $containerQuestionario = document.getElementById('container-questionario');

        

        let formData = new FormData();
        formData.append('token', token);
        formData.append('tipoPergunta', tipoPergunta);
        formData.append('resposta', resposta);

        const candidaturaPendente = obterCandidaturaPendente();

        if (candidaturaPendente.vagaID != '0') {
            formData.append('vagaID', candidaturaPendente.vagaID);
            formData.append('redirect', `${candidaturaPendente.url}?confirmar=1`);
        }

        const callbackSucesso = (resultado) => {
            loadFullPage.esconder();

            if (!resultado.acertou) {
                $containerQuestionario.innerHTML = `
                    <h2 class="h3 text-primary text-center mb-3">${i18next.t('RecuperarSenhaQuestionarioIncorreto')}</h2>
                    <div class="alert alert-warning text-center">${i18next.t('RecuperarSenhaQuestionarioIncorretoTexto')}
                        <p class="text-center"><a href="#" id="alteracaoPorEmail" class="btn w-100 btn-outline-primary mt-4">${i18next.t('RecuperarSenhaQuestionarioIncorretoOrientacoes')}</a></p>
                    </div>`;

                $containerQuestionario.querySelector('#alteracaoPorEmail').addEventListener('click', function () {
                    _callAlterarSenhaEmail();
                    return false;
                }, false);
                return;
            }
            if (resultado.link !== '') {
                $containerQuestionario.innerHTML = _templateFinalizouQuestionario(resultado.link);
                return;
            }
            $containerQuestionario.innerHTML = _templateQuestionario(resultado.pergunta.titulo, resultado.pergunta.alternativas);
            document.getElementById('TipoPergunta').value = resultado.pergunta.tipo;


            const btnsRespostas = $containerQuestionario.querySelectorAll('.btn-resposta');
            btnsRespostas.forEach((item) => {
                item.addEventListener('click', function (e) {
                    let resposta = this.innerHTML;
                    _callResponderQuestionario(resposta);
                    return false;
                }, false);
            });

        }
        const callbackErro = () => {
            loadFullPage.esconder();
        }

        await postFetch(`/${CULTURE_EMPREGARE}/Login/VerificarResposta`, formData, callbackSucesso, callbackErro, callbackErro);
    };

    const _callAlterarSenhaQuestionario = async function () {
        loadFullPage.mostrar();

        const token = document.getElementById('TokenUsuario').value;
        const $containerQuestionario = document.getElementById('container-questionario');

        const callbackSucesso = (resultado) => {
            loadFullPage.esconder();

            addTrack('Recuperacao Senha', { recuperacaoPor: 'questionario' });

            document.getElementById('container-escolher-alteracao').classList.add('d-none');

            $containerQuestionario.innerHTML = _templateQuestionario(resultado.pergunta.titulo, resultado.pergunta.alternativas);
            document.getElementById('TipoPergunta').value = resultado.pergunta.tipo;

            const btnsRespostas = $containerQuestionario.querySelectorAll('.btn-resposta');
            btnsRespostas.forEach((item) => {
                item.addEventListener('click', function (e) {
                    let resposta = this.innerHTML;
                    console.log(resposta);
                    _callResponderQuestionario(resposta);
                    return false;
                }, false);
            });

            $containerQuestionario.classList.remove('d-none');


        }
        const callbackErro = () => {
            loadFullPage.esconder();
        }

        let formData = new FormData();
        formData.append('token', token);

        const candidaturaPendente = obterCandidaturaPendente();
        if (candidaturaPendente.vagaID != '0') {
            formData.append('vagaID', candidaturaPendente.vagaID);
            formData.append('redirect', `${candidaturaPendente.url}?confirmar=1`);
        }

        await postFetch(`/${CULTURE_EMPREGARE}/Login/IniciarQuestionario`, formData, callbackSucesso, callbackErro, callbackErro);


    };

    const init = function () {
        inicializarInternacionalizacao();
        // var maskOptions = {
        //     mask: "000.000.000-00",
        // };
        // IMask($form.querySelector('#cpf'), maskOptions);

        const validar = new JustValidate($form, {
            errorFieldCssClass: "is-invalid"
        });
        validar
            // .addField("#paisID", [{ rule: "required", errorMessage: i18next.t('RecuperarSenhaFormularioValidacaoPais') },])
            // .addField("#cpf", [{ rule: "required", errorMessage: i18next.t('RecuperarSenhaFormularioValidacaoCpf') }])
            .addField("#emailCpf", [
                { rule: "required", errorMessage: i18next.t('RecuperarSenhaFormularioValidacaoEmailCpf') },
                // {
                //     rule: "email",
                //     errorMessage: i18next.t('RecuperarSenhaFormularioValidacaoEmailInvalido'),
                // },
            ]);

        $form.addEventListener('submit', function (e) {
            $form.querySelector('#row-erro').classList.add('d-none');
            validar.revalidate().then((isValid) => {
                if (isValid) {
                    _call();
                }
            });
            e.preventDefault();
        }, false);


        // $form.querySelector('#paisID').addEventListener('change', function () {
        //     var id = this.value;

        //     if (id == '') {
        //         document.getElementById('btn-esqueci-senha').classList.add('d-none');
        //         return;
        //     }
        //     document.getElementById('btn-esqueci-senha').classList.remove('d-none');
        //     if (id == 'BR') {
        //         document.getElementById('cpf-esqueci-senha').classList.remove('d-none');
        //         document.getElementById('email-esqueci-senha').classList.add('d-none');

        //         validar.removeField('#email');
        //         validar.addField("#cpf", [{ rule: "required", errorMessage: i18next.t('RecuperarSenhaFormularioValidacaoCpf') }]);

        //     } else {
        //         document.getElementById('cpf-esqueci-senha').classList.add('d-none');
        //         document.getElementById('email-esqueci-senha').classList.remove('d-none');
        //         validar.removeField('#cpf');
        //         validar.addField("#email", [
        //             { rule: "required", errorMessage: i18next.t('RecuperarSenhaFormularioValidacaoEmail') },
        //             {
        //                 rule: "email",
        //                 errorMessage: i18next.t('RecuperarSenhaFormularioValidacaoEmailInvalido'),
        //             },
        //         ]);
        //     }
        // }, false);

        // const geoData = getGeoData();
        
        // if (geoData.existe) {           
        //     $form.querySelector('#paisID').value = geoData.data.pais;
        //     if ("createEvent" in document) {
        //         var evt = document.createEvent("HTMLEvents");
        //         evt.initEvent("change", false, true);
        //         $form.querySelector('#paisID').dispatchEvent(evt);
        //     }
        //     else
        //         $form.querySelector('#paisID').fireEvent("onchange");

        // }

        document.getElementById('btnAlterarSenhaEmail').addEventListener('click', function () {

            _callAlterarSenhaEmail();
        }, false);

        document.getElementById('btnAlterarSenhaQuestionario').addEventListener('click', function () {

            _callAlterarSenhaQuestionario();
        }, false);


    }
    return init();
}

esqueciSenha();
// esqueciSenha();